// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbk_a bhs_i bhs_j","ColorVariants__color":"bbk_b bhs_rp","ColorVariants__more":"bbk_c bhs_vv"};